module.exports = __webpack_public_path__ + "static/media/logo.a741f98d.png";